import React, {Component} from 'react';
import { DRAGGABLE_ITEM_TYPES } from 'crazyEditor/core/constants/editorConstants';
import { DragLayer } from 'react-dnd';
import styles from './CustomMenuElementDraggableLayerStyles';
import Radium from 'radium';

function getItemStyles(props) {
  const { initialOffset, currentOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

@DragLayer(monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging()
}))
@Radium
export default class CustomMenuElementDraggableLayer extends Component {
  renderItem(type, item) {
    switch (type) {
      case DRAGGABLE_ITEM_TYPES.ADD_PANEL_ELEMENT:
        const elementLayout = item.elementPreset.layout;
        return (
          <div style={[{width: elementLayout.width, height: elementLayout.height}, styles.addPanel]}></div>
        );
      default:
        return null;
    }
  }

  render() {
    const { item, itemType, isDragging } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div style={styles.layer}>
        <div style={getItemStyles(this.props)}>
          {this.renderItem(itemType, item)}
        </div>
      </div>
    );
  }
}
